import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return ($setup.isExistOtherReply())
    ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        onClick: $setup.onclick,
        disabled: $props.isProcessingGetMoreReply,
        class: "revico-community-talk-reply-details--reply-count"
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-angle-right" }),
        _createTextVNode(" " + _toDisplayString($setup.displayText), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}